import { render, staticRenderFns } from "./prevtwo.vue?vue&type=template&id=00e9ec63&"
import script from "./prevtwo.vue?vue&type=script&lang=ts&"
export * from "./prevtwo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports